/**
 * Kop van het chatvenster op de telefoon (19-10-2026, Jordy). Alleen gerenderd
 * onder 900px (lib/mobiel); op desktop bestaat dit element niet.
 *
 * Regel 1: terug naar de inbox, model, platform, en de drie knoppen Model, Fan
 * en ⋯ (de schakelaars van de gewone kop). Regel 2: de fan met zijn wachttijd
 * en wat hij heeft uitgegeven. Model en Fan openen een lade over het gesprek
 * en staan bij elk geopend gesprek standaard dicht.
 */
import { Avatar, Plat, Tag, Wacht } from './ui'
import { eur } from '../lib/format'

export type MobielPaneel = 'model' | 'fan' | null

export function MobielChatKop({
  model,
  avatar,
  platform,
  fan,
  wachtSinds,
  uitgegeven,
  paneel,
  onPaneel,
  acties,
  onActies,
  onTerug,
  ingeklapt = false,
  onKlap,
}: {
  model: string
  avatar?: string | null
  platform: string
  fan: string
  wachtSinds?: string | null
  uitgegeven?: number
  paneel: MobielPaneel
  onPaneel: (p: MobielPaneel) => void
  acties: boolean
  onActies: (open: boolean) => void
  onTerug: () => void
  /** 19-10-2026 (Jordy): ingeklapt = één smalle strip, meer ruimte voor de chat. */
  ingeklapt?: boolean
  onKlap?: (ingeklapt: boolean) => void
}) {
  const wissel = (p: 'model' | 'fan') => onPaneel(paneel === p ? null : p)
  if (ingeklapt) {
    return (
      <div className="mchatkop mchatkop-in" data-testid="mobiel-kop">
        <button type="button" className="btn ghost sm mterug" aria-label="Back to chats"
                title="Back to chats" data-testid="mobiel-terug" onClick={onTerug}>
          <span aria-hidden="true">←</span>
        </button>
        <button type="button" className="mkopstrip" data-testid="mobiel-kop-klap"
                aria-expanded={false} title="Show the header" onClick={() => onKlap?.(false)}>
          <b>{model}</b><span className="mut2"> · {fan}</span>
          <span className="mkoppijl" aria-hidden="true">▾</span>
        </button>
        {/* 20-10-2026 (Jordy): ook ingeklapt blijven Model en Fan bereikbaar
            (een chatter kon de Model info niet meer openen). */}
        <button type="button" className={paneel === 'model' ? 'btn sm on' : 'btn ghost sm'}
                aria-pressed={paneel === 'model'} onClick={() => wissel('model')}>Model</button>
        <button type="button" className={paneel === 'fan' ? 'btn sm on' : 'btn ghost sm'}
                aria-pressed={paneel === 'fan'} onClick={() => wissel('fan')}>Fan</button>
      </div>
    )
  }
  return (
    <div className="mchatkop" data-testid="mobiel-kop">
      <div className="mchatkop-r1">
        {/* 19-10-2026 (Jordy): duidelijk terug naar het chatoverzicht. */}
        <button type="button" className="btn ghost sm mterug" aria-label="Back to chats"
                title="Back to chats" data-testid="mobiel-terug" onClick={onTerug}>
          <span aria-hidden="true">←</span> Chats
        </button>
        <Avatar name={model} src={avatar} size={22} />
        <b className="mchatkop-model">{model}</b>
        <Plat value={platform} />
        <span className="spacer" style={{ flex: 1 }} />
        <button type="button" className={paneel === 'model' ? 'btn sm on' : 'btn ghost sm'}
                aria-pressed={paneel === 'model'} onClick={() => wissel('model')}>
          Model
        </button>
        <button type="button" className={paneel === 'fan' ? 'btn sm on' : 'btn ghost sm'}
                aria-pressed={paneel === 'fan'} onClick={() => wissel('fan')}>
          Fan
        </button>
        <button type="button" className={acties ? 'btn sm on' : 'btn ghost sm'}
                aria-expanded={acties} aria-label="More actions" title="More actions"
                onClick={() => onActies(!acties)}>
          ⋯
        </button>
        {onKlap ? (
          <button type="button" className="btn ghost sm mkopklap" data-testid="mobiel-kop-klap"
                  aria-expanded={true} aria-label="Collapse the header" title="Collapse the header"
                  onClick={() => onKlap(true)}>▴</button>
        ) : null}
      </div>
      <div className="mchatkop-r2">
        <span className="mchatkop-fan">{fan}</span>
        {wachtSinds ? <Wacht sinds={wachtSinds} /> : null}
        {uitgegeven && uitgegeven > 0 ? <Tag kind="warn">★ {eur(uitgegeven)}</Tag> : null}
      </div>
    </div>
  )
}
